function initAccordions() {
	// Find and iterate through all of the uninitialized accordions
	let didInitialize = false;
	let pageAccordions = document.querySelectorAll('.js-accordion-button:not([data-init="true"])');
	if (pageAccordions !== null && pageAccordions.length) {
		didInitialize = true;
		pageAccordions.forEach(function (accordion, index) {
			// See if it has a valid cotnent section
			let accordionContent = accordion.parentNode.querySelector(".js-accordion-content") as HTMLElement;
			if (accordionContent !== null) {
				// Set up the properties
				accordion.setAttribute("aria-expanded", "false");
				let ran = Math.floor(Math.random() * 10000000000000);
				accordion.setAttribute("aria-controls", "ac_" + ran);
				accordion.setAttribute("id", "ach_" + ran);
				accordionContent.setAttribute("id", "ac_" + ran);
				// accordionContent.setAttribute("aria-labeledby", "ach_" + ran);

				// Attach the click events
				accordion.addEventListener("click", function (event) {
                    const target = event.target as Element;
					const mobileNavParent = getParentElementWithClass(this, "site-nav");
					if (mobileNavParent) {
						mobileNavParent.parentNode.classList.toggle("menu-open");
					}
					if (!target.classList.contains("arrow-lnk")) {
						this.parentNode.classList.toggle("active");
						vSlideToggle(accordionContent,);
					}

					if (this.getAttribute("aria-expanded") == "true") {
						this.setAttribute("aria-expanded", "false");
					} else {
						this.setAttribute("aria-expanded", "true");
					}
				});
				let accordionClose = accordion.parentElement.querySelector(".js-accordion-close");
				if (accordionClose) {
					accordionClose.addEventListener("click", function (event) {
						accordion.parentElement.classList.remove("active");
						vSlideUp(accordionContent);
						accordion.setAttribute("aria-expanded", "false");
					});
				}

				// Hide all accordion content on page load
				if (accordion.parentElement.classList.contains("js-mobile-only")) {
					if (window.innerWidth < TABLETBREAK) {
						accordionContent.style.display = "none";
					}
					window.addEventListener("resize", function () {
						if (
							window.innerWidth >= TABLETBREAK &&
							accordion.parentElement.classList.contains("js-mobile-only") &&
							(accordionContent.style.display == "none" ||
								getComputedStyle(accordionContent).display == "none")
						) {
							accordionContent.style.display = "block";
						} else if (
							window.innerWidth < TABLETBREAK &&
							accordion.parentElement.classList.contains("js-mobile-only") &&
							!accordion.parentElement.classList.contains("active") &&
							(accordionContent.style.display == "block" ||
								getComputedStyle(accordionContent).display == "block")
						) {
							accordionContent.style.display = "none";
						}
					});
				} else {
					accordionContent.style.display = "none";
				}

				const hash = window.location.hash;

				if (hash) {
					if (accordion.parentElement.getAttribute('anchor') == hash) {
						accordion.parentElement.classList.add('active');
						accordionContent.style.display = "block";
					}
				}

				// Set a property of the accordion so we can tell it was initialized. Accordions without this property will be initialized by initAccordions();
				accordion.setAttribute("data-init", "true");
			}
		});
	}
	return didInitialize;
}
// Accordion Script -- fire if accordions exist
initAccordions();
